import { useCallback, useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import { api } from "@/lib/api";
import { Thread, Composer } from "@/pages/admin/Messages";
import { Reactions } from "@/components/Reactions";
import { VoiceReply } from "@/components/VoiceReply";
import { BrandLogo } from "@/components/Brand";

export const ClientChat = ({ brand }) => {
  const [d, setD] = useState(null);
  const [tab, setTab] = useState("coach");
  const load = useCallback(() => api.get("/client/me/chat").then((r) => setD(r.data)).catch(() => setD(false)), []);
  useEffect(() => { load(); const t = setInterval(load, 20000); return () => clearInterval(t); }, [load]);
  if (d === false) return null;
  const send = async (body) => { await api.post("/client/me/chat", { body }); await load(); };
  const first = (d?.coachName || "Coach").split(" ")[0];
  return (
    <div className="panel chat-card" data-testid="client-chat">
      <div className="tabs" style={{ marginBottom: 8 }} data-testid="client-chat-tabs">
        <button className={tab === "coach" ? "on" : ""} onClick={() => setTab("coach")} data-testid="client-chat-tab-coach">Chat with {first}</button>
        <button className={tab === "community" ? "on" : ""} onClick={() => setTab("community")} data-testid="client-chat-tab-community"><Megaphone size={12} style={{ marginRight: 4, verticalAlign: -1 }} />Community{d?.announcements?.length ? ` · ${d.announcements.length}` : ""}</button>
      </div>
      {tab === "coach" ? (
        <>
          <div className="chat-head compact" data-testid="client-chat-head"><BrandLogo brand={brand} size={32} testId="client-chat-logo" /><div className="sb"><div className="st">{d?.coachName || "Your coach"}</div><div className="ss">{d?.studioName || ""} · replies land on your coach's phone & email</div></div></div>
          <Thread messages={d?.messages} idPrefix="client-msg" isMine={(m) => m.direction === "INBOUND"} emptyText="No messages yet — your coach's notes, reminders and check-ins will show up here."
            renderExtra={(m) => m.direction !== "INBOUND" ? <div style={{ marginTop: 6 }}><Reactions message={m} onChanged={(r) => setD({ ...d, messages: d.messages.map((x) => (x.id === r.id ? { ...x, reaction: r.reaction } : x)) })} />{m.voiceNoteId && <VoiceReply replyTo={m.id} onSent={load} />}</div> : null} />
          <Composer onSend={send} testId="client-chat" placeholder={`Message ${first}…`} />
        </>
      ) : (
        <>
          <div className="chat-head compact" data-testid="client-community-head"><span className="conv-mega" style={{ width: 32, height: 32 }}><Megaphone size={16} /></span><div className="sb"><div className="st">Community — All Clients</div><div className="ss">Announcements from {d?.studioName || "your coach"} · broadcast only</div></div></div>
          <Thread messages={d?.announcements ? [...d.announcements].reverse() : null} idPrefix="client-announcement" isMine={() => false} emptyText="No announcements yet." />
          <div className="ss" style={{ textAlign: "center", padding: "8px 0 2px" }} data-testid="client-community-readonly">You can't reply to community posts — message {first} directly instead.</div>
        </>
      )}
    </div>
  );
};
